import {Message} from '../../model/message/message';
import {StandardAction} from './standard-action';

export class MessageAction extends StandardAction {

  public messages: Message[] = [];

  public get hasNoRead(): boolean {
    return !!this.messages.find(m => !m.isRead);
  }

  constructor(name: string, icon = 'bell', tooltip = 'action.notification') {
    super(name, icon, null, tooltip);
    this.align = 'right';
    this.category = 'message';
  }
}
